<header>
    <nav class="navbar navbar-expand-lg justify-content-between navbar-light ">
        
    </nav>
</header>

<div class="container" *ngIf="showPage == 1">
    <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-8 col-xs-8 mt-4 bg-format">
            <div class="login_here">
                <form id="login-form" class="form_login" [formGroup]="uploadReviewImageFG">
                    <h3 class="text-center"><img loading="lazy" src="../../../assets/images/new/myvip_logo.png"></h3>
                    <p class="text-center" *ngIf="uploadStatus == 'null'"><i class="fas fa-exclamation-circle fa-2x"></i></p>
                    <h3 class="text-center" *ngIf="uploadStatus == 'null'">Review not exists.</h3>
                    <p class="text-center" *ngIf="uploadStatus == 'error'"><i class="fas fa-exclamation-circle fa-2x"></i></p>
                    <h3 class="text-center" *ngIf="uploadStatus == 'error'">Something went wrong.</h3>
                    <p class="text-center" *ngIf="uploadStatus == 'success'"><i class="fas fa-check-circle fa-2x"></i></p>
                    <h3 class="text-center" *ngIf="uploadStatus == 'success'">Image uploaded.</h3>
                    <p class="text-center" *ngIf="uploadStatus == 'expired'"><i class="fas fa-exclamation-circle fa-2x"></i></p>
                    <h3 class="text-center" *ngIf="uploadStatus == 'expired'">Linked Expired.</h3>
                    <p class="text-center" *ngIf="uploadStatus == 'user_expired'"><i class="fas fa-exclamation-circle fa-2x"></i></p>
                    <h3 class="text-center" *ngIf="uploadStatus == 'user_expired'">Upload link has expired. Please contact customer service for a new link.</h3>
                    <p class="text-center" *ngIf="uploadStatus == 'not_sent'"><i class="fas fa-exclamation-circle fa-2x"></i></p>
                    <h3 class="text-center" *ngIf="uploadStatus == 'not_sent'">Message not sent yet</h3>
                    <h3 class="text-center" *ngIf="uploadStatus == 'default'">Upload Review Image</h3>
                    <p class="forgot mb-4" *ngIf="uploadStatus == 'default'">Please select image. Link will expire in 3 days. <br><span *ngIf="manual_type == 1">Turn OFF Location & Wifi, use Mobile Data.</span></p>

                    <div class="form-group" *ngIf="uploadStatus == 'default'">
                        <!-- <span>Please select image. Link will expire in 3 days</span> -->
                        <!-- <br> -->
                        <input type="file" name="image" id="" class="form-control" accept="image/*" (change)="onFileChanged($event)" />
                        <input type="hidden" name="fileHidden" formControlName="imageInput"/>
                        <ng-container *ngIf="submitted && uploadReviewImageFG_v.imageInput.errors">
                            <p class="error-message" *ngIf=" uploadReviewImageFG_v.imageInput.errors.required">
                                Image is required!
                            </p>
                        </ng-container>
                    </div>
                    
                    <div class="form-group" *ngIf="uploadStatus == 'default'">
                        <div class="row align-items-center">
                            <div class="col-md-12 text-center">
                                <div class="login_button mt-4">
                                    <a (click)="uploadImageData()"> Submit </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <ng-container *ngIf="manual_type == 1">
                    <!-- <p style="color: white;">Try to use your phone to write the reviews. PC sometimes may cause Google to hide the reviews from public.</p> -->
                    <p style="color: white;">
                        1. Use Mobile Phone to write reviews (Turn Off WIFI). Using PC with Wifi will cause Google to hide your reviews from public. 
                    </p>
                    <br>
                    <p style="color: white;">
                        2. To check if your review is hidden from public, open incognito mode and don't log into account then check. 
                    </p>
                    <br>
                    <h3 class="text-center"><img loading="lazy" src="../../../assets/images/new/manual1.jpg"></h3>
                </ng-container>
                <ng-container *ngIf="manual_type == 2">
                    <p style="color: white;">1. Reviews and Mentions are NOT the same.</p>
                    <br>
                    <p style="color: white;">2. Please set Reviews to Public. If unsure see below.</p>
                    <br>
                    <h3 class="text-center"><img loading="lazy" src="../../../assets/images/new/fb_img.jpg"></h3>
                    <br>
                    <h3 class="text-center"><img loading="lazy" src="../../../assets/images/new/fb_img2.jpg"></h3>
                </ng-container>
                <ng-container *ngIf="manual_type == 3">
                    <p style="color: white;">Make an Offer, Wait for Acceptance, write Random address and give Desired delivery date.</p>
                    <br>
                    <h3 class="text-center"><img loading="lazy" src="../../../assets/images/new/manual3.jpg"></h3>
                </ng-container>
            </div>
        </div>
    </div>
</div>